import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import "../assets/css/agent/features-tab.scss";
import { MdMessage } from "react-icons/md";
import { FaPhoneAlt, FaInbox } from "react-icons/fa";
import { HiTicket } from "react-icons/hi";
import { CgNotes } from "react-icons/cg";
import axiosInstance from "../environment/axiosInstance";

function FeaturesTab() {
    const { userId } = useParams();
    const [total_chats, setTotalChats] = useState(0);
    const [total_calls, setTotalCalls] = useState(0);
    const [total_tickets, setTotalTickets] = useState(0);
    const [total_emails, setTotalEmails] = useState(0);

    useEffect(() => {
        axiosInstance
            .get(process.env.REACT_APP_API_URL + "/support/business_owner/customer/" + userId)
            .then(response => {
                if (response.data.statusCode == 200) {
                    setTotalChats(response.data.Data?.chats.length);
                    setTotalCalls(response.data.Data?.calls.length);
                    setTotalTickets(response.data.Data?.tickets.length);
                    setTotalEmails(response.data.Data?.emails?.length ? response.data.Data?.emails?.length : 0);
                }
            });
    }, [userId]);

    return (
        <div className="features-tab">
            <div className="bottom-row">
                <div className="d-flex align-items-center text-tabs">
                    <Link to={"/conversations/" + userId}
                        className={
                            "text-tab" + (
                                window.location.href.includes("/conversations/") ?
                                    " active-tab" : ""
                            )
                        }>
                        <div className="d-flex align-items-center">
                            <p className="m-0">Chats</p>
                            <div className="badge">
                                <p className="m-0">{total_chats}</p>
                            </div>
                        </div>
                    </Link>
                    <Link to={"/calls/" + userId}
                        className={
                            "text-tab" + (
                                window.location.href.includes("/calls/") ?
                                    " active-tab" : ""
                            )
                        }
                    >
                        <div className="d-flex align-items-center">
                            <p className="m-0">Calls</p>
                            <div className="badge">
                                <p className="m-0">{total_calls}</p>
                            </div>
                        </div>
                    </Link>
                    <Link to={"/tickets/" + userId}
                        className={
                            "text-tab" + (
                                window.location.href.includes("/tickets/") ?
                                    " active-tab" : ""
                            )
                        }
                    >
                        <div className="d-flex align-items-center">
                            <p className="m-0">Tickets</p>
                            <div className="badge">
                                <p className="m-0">{total_tickets}</p>
                            </div>
                        </div>
                    </Link>
                    <Link to={"/emails/" + userId}
                        className={
                            "text-tab" + (
                                window.location.href.includes("/emails/") ?
                                    " active-tab" : ""
                            )
                        }
                    >
                        <div className="d-flex align-items-center">
                            <p className="m-0">Emails</p>
                            <div className="badge">
                                <p className="m-0">{total_emails}</p>
                            </div>
                        </div>
                    </Link>
                </div>
                {/* <div className="d-flex align-items-center">
                    <Link
                        to={"/conversations/" + userId}
                        className="ms-3"
                    >
                        <div className={"tab " + (window.location.href.includes("/conversations/") ? "active" : "")}>
                            <MdMessage
                                color={window.location.href.includes("/conversations/") ? "white" : "gray"}
                                size={15}
                            />
                            <div className={"badge " + (window.location.href.includes("/conversations/") ? "active-badge" : "")}>
                                <p className="m-0">{total_chats}</p>
                            </div>
                        </div>
                    </Link>
                    <Link
                        to={"/calls/" + userId}
                        className="ms-3"
                    >
                        <div className={"tab " + (window.location.href.includes("/calls/") ? "active" : "")}>
                            <FaPhoneAlt
                                color={window.location.href.includes("/calls/") ? "white" : "green"}
                                size={14}
                            />
                            <div className={"badge " + (window.location.href.includes("/calls/") ? "active-badge" : "")}>
                                <p className="m-0">{total_calls}</p>
                            </div>
                        </div>
                    </Link>
                    <Link
                        to={"/tickets/" + userId}
                        className="ms-3"
                    >
                        <div className={"tab " + (window.location.href.includes("/tickets/") ? "active" : "")}>
                            <HiTicket
                                color={window.location.href.includes("/tickets/") ? "white" : "gray"}
                                size={18}
                            />
                            <div className={"badge " + (window.location.href.includes("/tickets/") ? "active-badge" : "")}>
                                <p className="m-0">{total_tickets}</p>
                            </div>
                        </div>
                    </Link>
                    <Link
                        to={"/emails/" + userId}
                        className="ms-3"
                    >
                        <div className={"tab " + (window.location.href.includes("/emails/") ? "active" : "")}>
                            <FaInbox
                                color={window.location.href.includes("/emails/") ? "white" : "gray"}
                                size={16}
                            />
                            <div className={"badge " + (window.location.href.includes("/emails/") ? "active-badge" : "")}>
                                <p className="m-0">{total_emails}</p>
                            </div>
                        </div>
                    </Link>
                </div> */}
            </div>
        </div>
    )
}

export default FeaturesTab;